/**
 * Cache key serialization utilities
 */

import type { CacheKey } from "../types";

/**
 * Create a cache key string from CacheKey object
 */
export function createCacheKey(key: CacheKey): string {
  const parts = [
    key.action,
    key.parentId || "root",
    key.driveId || "none",
    key.email || "default",
    key.isSecondAccount ? "secondary" : "primary",
  ];
  return parts.join("|");
}

/**
 * Parse cache key string back to CacheKey object
 */
export function parseCacheKey(keyString: string): CacheKey {
  const [action, parentId, driveId, email, account] = keyString.split("|");
  return {
    action: action as "list" | "drives",
    parentId: parentId === "root" ? undefined : parentId,
    driveId: driveId === "none" ? undefined : driveId,
    email: email === "default" ? undefined : email,
    isSecondAccount: account === "secondary",
  };
}

/**
 * Validate cache key
 */
export function isValidCacheKey(key: CacheKey): boolean {
  return key.action === "list" || key.action === "drives";
}

/**
 * Create cache key for list action
 */
export function createListCacheKey(
  parentId: string | undefined,
  driveId: string | undefined,
  email: string | undefined,
  isSecondAccount: boolean
): CacheKey {
  return {
    action: "list",
    parentId,
    driveId,
    email,
    isSecondAccount,
  };
}

/**
 * Create cache key for drives action
 */
export function createDrivesCacheKey(
  email: string | undefined,
  isSecondAccount: boolean
): CacheKey {
  return {
    action: "drives",
    email,
    isSecondAccount,
  };
}
